import React from "react";
import { Box, Chip } from "@mui/material";
import { alpha } from "@mui/material/styles";

const TONE_BY_STATUS = {
    active: "success",
    inactive: "error",
    pending: "warning",
    info: "info",
    neutral: "default",
};

const StatusBadge = ({ status = "neutral", label, size = "small", showDot = true }) => {
    const tone = TONE_BY_STATUS[status] || "default";

    return (
        <Chip
            size={size}
            label={
                <Box sx={{ display: "flex", alignItems: "center", gap: 0.75 }}>
                    {showDot && (
                        <Box
                            sx={(theme) => ({
                                width: 8,
                                height: 8,
                                borderRadius: "50%",
                                bgcolor:
                                    tone === "default"
                                        ? theme.palette.text.disabled
                                        : theme.palette[tone].main,
                            })}
                        />
                    )}
                    {label}
                </Box>
            }
            sx={(theme) => ({
                bgcolor:
                    tone === "default"
                        ? alpha(theme.palette.text.primary, 0.06)
                        : alpha(theme.palette[tone].main, 0.12),
                color:
                    tone === "default"
                        ? theme.palette.text.secondary
                        : theme.palette[tone].main,
                fontWeight: 600,
                border: "none",
                "& .MuiChip-label": { paddingInline: 1 },
            })}
        />
    );
};

export default StatusBadge;